<template>
   <EquipmentAIODetail v-if="type === 'aio'" />
   <EquipmentAIOTwoDetail v-else-if="type === 'aio2'" />
   <EquipmentBoxDetail v-else-if="type === 'box'" />
   <EquipmentBoxVenueDetail v-else-if="type === 'box-venue'" />
   <EquipmentSitDetail v-else-if="type === 'sit'" />
</template>

<script>
import EquipmentAIODetail from './EquipmentAIO/EquipmentAIODetail.vue';
import EquipmentAIOTwoDetail from './EquipmentAIOTwo/EquipmentAIOTwoDetail.vue';
import EquipmentBoxDetail from './EquipmentBox/EquipmentBoxDetail.vue';
import EquipmentBoxVenueDetail from './EquipmentBoxVenue/EquipmentBoxVenueDetail.vue';
import EquipmentSitDetail from './EquipmentSit/EquipmentSitDetail.vue';

export default {
   components: {
      EquipmentAIODetail,
      EquipmentAIOTwoDetail,
      EquipmentBoxDetail,
      EquipmentBoxVenueDetail,
      EquipmentSitDetail
   },

   data() {
      return {
         type: ''
      }
   },

   mounted() {
      this.type = this.$util.getUrlParam("type");
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// EquipmentDetail.vue?96aeed60